<div class="flex flex-col self-stretch gap-2.5">
  <h1 class="certificate-holder-headline">New Certificate Holder</h1>
  <p class="certificate-holder-subtext">
    Welcome to your central Certificate Holder Management dashboard, the ultimate hub for organizing and managing your recipient records.<br>
    Here, you can effortlessly navigate your entire directory to access, update, or clone existing profiles at a moment's notice. <br>
    If you need to expand your list, simply select the "Add Certificate Holder" button to launch a blank profile workspace.
  </p>
  <span class="w-fit"
        [pTooltip]="permissionService.hasEditRights() ? 'Create a new Certificate Holder' : 'Insufficient permissions'"
  >
    <button pButton
            type="button"
            data-test="certificate-holder-new-button"
            severity="primary"
            [disabled]="!permissionService.hasEditRights()"
            (click)="router.navigate(['/certificate-holder/create'])"
    >
      New Certificate Holder
    </button>
  </span>
</div>
